import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ThemeMode, ThemeColors } from '@alvo/types';
import { darkTheme, lightTheme } from '@alvo/types';

interface ThemeState {
  mode: ThemeMode;
  colors: ThemeColors;

  // Actions
  setMode: (mode: ThemeMode) => void;
  toggleMode: () => void;
  isDark: () => boolean;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      mode: 'dark',
      colors: darkTheme,

      setMode: (mode) => {
        set({
          mode,
          colors: mode === 'dark' ? darkTheme : lightTheme
        });
      },

      toggleMode: () => {
        const { mode } = get();
        const newMode = mode === 'dark' ? 'light' : 'dark';
        set({
          mode: newMode,
          colors: newMode === 'dark' ? darkTheme : lightTheme
        });
      },

      isDark: () => get().mode === 'dark'
    }),
    {
      name: 'alvo-theme'
    }
  )
);

// Convenience hooks
export const useColors = () => useThemeStore((state) => state.colors);
export const useIsDarkMode = () => useThemeStore((state) => state.mode === 'dark');
